import { Flex, Image, Link, Text } from "@chakra-ui/react";
import React, { memo } from "react";

export default memo(function SupportCardComponent({ item }) {
   function showLinkComponent(linkUrl) {
      return (
         <Link
            href={linkUrl}
            w={"full"}
            userSelect="none"
            style={{ textDecoration: "none" }}
            isExternal
            fontSize={14}
            color="blue.500"
            fontFamily={'Arial-BoldMT'}
            h={"32px"}
            mt={"12px"}
            textAlign="center"
            _focus={{ boxShadow: "none" }}
            lineHeight={"32px"}
            bg={"white"}
            _hover={{ color: "blue.600" }}
            borderRadius={"16px"}
            border={"1px solid #E6E6E6"}>
            Explore what’s happening on Twitter
         </Link>
      );
   }
   return (
      <>
         <Link
            href={item.twitter_url}
            style={{ textDecoration: "none" }}
            isExternal
            mt={"30px"}
            textAlign="center"
            _focus={{ boxShadow: "none" }}>
            <Flex alignItems={"center"} >
               <Image
                  userSelect="none"
                  className="refImg"
                  src={undefined}
                  boxSize={"44px"}
                  borderRadius="full"
                  data-src={process.env.REACT_APP_PUBLIC_URL + item.icon}
               />
               <Text ml={"15px"} variant={'16_black_bold'}>
                  {item.title}
               </Text>
            </Flex>
         </Link>

         <Image
            userSelect="none"
            className="refImg"
            src={undefined}
            mt={"12px"}
            data-src={process.env.REACT_APP_PUBLIC_URL + item.pic}
            h={"354px"}
         />
         {showLinkComponent(item.twitter_url)}
      </>
   );
});
